import { useEffect } from 'react';

const PostHogAnalytics = () => {
    useEffect(() => {
        // Check if PostHog is already initialized to prevent duplicates
        if (window.posthog && window.posthog.__loaded) return;

        // Standard PostHog initialization snippet
        !function (t, e) { var o, n, p, r; e.__SV || (window.posthog = e, e._i = [], e.init = function (i, s, a) { function g(t, e) { var o = e.split("."); 2 == o.length && (t = t[o[0]], e = o[1]), t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } } (p = t.createElement("script")).type = "text/javascript", p.async = !0, p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js", (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r); var u = e; for (void 0 !== a ? u = e[a] = [] : a = "posthog", u.people = u.people || [], u.toString = function (t) { var e = "posthog"; return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e }, u.people.toString = function () { return u.toString(1) + ".people (stub)" }, o = "capture identify alias people set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing set_person_properties group growl trailer badge get_property getSessionId get_distinct_id get_groups set_group_properties reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures onSessionId".split(" "), n = 0; n < o.length; n++)g(u, o[n]); e._i.push([i, s, a]) }, e.__SV = 1) }(document, window.posthog || []);

        // Initialize with hardcoded keys to guarantee it works on Vercel
        window.posthog.init('phc_eEFOKZblZcWgApjIgScYSInTTPYuhuHhZwjEkfpOOBj', {
            api_host: 'https://eu.i.posthog.com',
            person_profiles: 'identified_only',
            autocapture: false,
            disable_toolbar: true,
            advanced_disable_toolbar: true,
            advanced_disable_decide: true,
            disable_surveys: true,
            opt_in_site_apps: false,
            loaded: function (posthog) {
                posthog.__loaded = true;
            }
        });
    }, []);

    return null; // This component doesn't render any visible UI
};

export default PostHogAnalytics;
